<template>
  <div class="catalog small-scroll-bar small-scroll-bar--black">
    <div class="catalog-container">
      <materials-banner />
    </div>

    <div class="catalog-container">
      <materials-stories />
    </div>

    <div class="catalog_inner">
      <materials-header
        class="catalog-container"
        :selected-category.sync="selectedCategory"
        @search="searchInput = $event"
      />

      <materials-list
        class="catalog-container"
        :search-input="searchInput"
        :selected-category="selectedCategory"
      />

      <materials-subscription
        class="catalog-container"
      />

      <materials-popular
        class="catalog-container"
      />
    </div>

    <materials-blocks
      class="catalog-container"
    />

    <school-new-form
      class="catalog-container"
    />

    <main-necessary
      class="catalog-container"
    />

    <school-new-breadcrumbs
      class="catalog-container"
      :breadcrumbs="breadcrumbs"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HeadMixin from '~/mixins/HeadMixin';

import SchoolNewForm from '~/components/v2/school-new/SchoolNewForm.vue';
import MainNecessary from '~/components/v2/main/MainNecessary.vue';
import MaterialsBanner from '~/components/materials/MaterialsBanner.vue';
import MaterialsHeader from '~/components/materials/MaterialsHeader.vue';
import MaterialsList from '~/components/materials/MaterialsList.vue';
import MaterialsBlocks from '~/components/materials/MaterialsBlocks.vue';
import SchoolNewBreadcrumbs from '~/components/v2/school-new/SchoolNewBreadcrumbs.vue';
import MaterialsPopular from '~/components/materials/MaterialsPopular.vue';
import MaterialsSubscription from '~/components/materials/MaterialsSubscription.vue';
import MaterialsStories from '~/components/materials/MaterialsStories.vue';
import { getCategoryShareImage } from '~/components/materials/utils';

export default {
  name: 'CatalogPage',
  components: {
    MaterialsStories,
    MaterialsSubscription,
    MaterialsPopular,
    SchoolNewBreadcrumbs,
    MaterialsBlocks,
    MaterialsList,
    MaterialsHeader,
    MaterialsBanner,
    SchoolNewForm,
    MainNecessary,
  },

  mixins: [HeadMixin],
  layout: 'DefaultLayoutV2',
  scrollToTop: true,

  data: () => ({
    materials: [],
    selectedCategory: {},
    pagination: {},

    searchInput: '',
  }),

  computed: {
    ...mapGetters({
      categories: 'getMaterialCategories',
    }),
    breadcrumbs() {
      return [
        { text: 'главная', to: '/' },
        { text: 'медиа «за школой»', to: this.$route.path },
      ];
    },
    currentCategory() {
      const pageCategory = this.$route.params.material_category;
      return this.categories.find(({ slug }) => pageCategory === slug) || {};
    },

    // для head
    title() {
      // eslint-disable-next-line
      return this.currentCategory?.title || 'Медиа для родителей и детей: образование, школа, ЕГЭ, ОГЭ, профессии, психология';
    },
    description() {
      // eslint-disable-next-line
      return this.currentCategory?.description || 'В нашем блоге найдете актуальные новости, советы по домашнему обучению, статьи о психологии ребенка, лайфхаки для успешной учебы, информацию о профессиях, а также полезные советы для родителей';
    },
    image() {
      return getCategoryShareImage(this.selectedCategory);
    },
  },

  beforeMount() {
    const routeCategory = this.$route.params?.material_category || 'articles';
    const foundRouteCategory = this.categories.find((category) => category.slug === routeCategory);
    if (foundRouteCategory) {
      this.selectedCategory = foundRouteCategory;
    }
  },
};
</script>

<style lang="scss" scoped>

.catalog {
  padding-top: calc(var(--scale) * 120);
  padding-bottom: calc(var(--scale) * 58);
  background-color: #ECEDF0;
  overflow: hidden;

  @include media-down($size-tablet) {
    padding-top: calc(var(--scale) * 104);
    padding-bottom: calc(var(--scale) * 24);
  }

  ::v-deep(*) {
    font-family: "Onest", sans-serif !important;
  }

  ::v-deep(.main-title) {
    position: relative;
    font-family: 'Onest', sans-serif;

    p {
      position: absolute;
      left: 0;
      top: 1.25rem;

      font-weight: 500;
      font-size: 1.625rem;
      line-height: 120%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        font-size: 1.8rem;
      }

      @include media-down($size-mobile) {
        position: relative;
        top: 0;
        margin-bottom: -0.2rem;
      }

      & + h2 {
        text-indent: calc(var(--scale) * 465);

        @include media-down($size-tablet) {
          text-indent: calc(var(--scale) * 186);
        }

        @include media-down($size-mobile) {
          text-indent: 0;
        }
      }
    }

    h2 {
      font-weight: 500;
      font-size: 5.375rem;
      line-height: 110%;
      letter-spacing: -0.04em;
      color: #02120F;

      @include media-down($size-tablet) {
        font-size: 4rem;
      }

      span {
        color: #A7ABAC;
      }
    }
  }

  .catalog-container {
    margin-inline: calc(var(--scale) * 40);

    @include media-down($size-tablet) {
      margin-inline: calc(var(--scale) * 16);
    }

    @include media-down($size-mobile) {
      margin-inline: calc(var(--scale) * 12);
    }
  }

  .materials-banner {
    margin-bottom: calc(var(--scale) * 20);
  }

  .materials-stories {
    margin-bottom: calc(var(--scale) * 68);
  }

  .catalog_inner {
    margin-bottom: calc(var(--scale) * 68);
    width: 100%;
    padding-block: calc(var(--scale) * 60);
    background-color: #FFFFFF;
    border-radius: calc(var(--scale) * 60);

    @include media-down($size-tablet) {
      margin-bottom: calc(var(--scale) * 40);
      padding-block: calc(var(--scale) * 40);
      border-radius: calc(var(--scale) * 20);
    }

    @include media-down($size-mobile) {
      margin-bottom: calc(var(--scale) * 65);
      padding-block: calc(var(--scale) * 16);
    }

    .materials-header {
      margin-bottom: calc(var(--scale) * 80);

      @include media-down($size-mobile) {
        margin-bottom: calc(var(--scale) * 40);
      }
    }
  }

  .materials-subscription,
  .materials-list,
  .materials-blocks,
  .school-new-form,
  .main-necessary {
    margin-bottom: calc(var(--scale) * 128);

    @include media-down($size-tablet) {
      margin-bottom: calc(var(--scale) * 80);
    }
  }
}

// артефакты от старых страниц
::v-deep section {
  margin-bottom: 0;

  h2,
  h3 {
    margin: 0;
  }
}

</style>
